import { Button, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import Main from "../../components/layout/Main";
import { useSettings } from "../../context/SettingsContext";

function PlatformPolicies() {
  const [activeKey, setActiveKey] = useState("1");
  const [content, setContent] = useState("");
  const { getContent } = useSettings();

  const onChange = (key) => {
    setActiveKey(key);
    // call API again when switching tabs
    handleFetch(key);
  };

  // ------------ API Handler -----------
  const fetchContent = async (contentType, lng) => {
    try {
      const response = await getContent(contentType, lng, {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": lng || "en",
        },
      });

      if (response?.success) {
        console.log(response, "Response----");
        setContent(response.data.data?.page.content);
      }
    } catch (error) {
      console.log(error, "---error-->");
    }
  };

  // map tab key → content type
  const handleFetch = (key) => {
    switch (key) {
      case "1":
        fetchContent("termsAndConditions", "en");
        break;
      case "2":
        fetchContent("privacyPolicy", "en");
        break;
      case "3":
        fetchContent("xpPolicy", "en");
        break;
      case "4":
        fetchContent("assecories", "en");
        break;
      default:
        fetchContent("termsAndConditions", "en");
    }
  };

  useEffect(() => {
    handleFetch(activeKey);
  }, []);

  const items = [
    {
      key: "1",
      label: (
        <Button
          className="Conditions-btn"
          style={{
            background: activeKey === "1" ? "#F2F0F0E3" : "#54545433",
            color: activeKey === "1" ? "#000" : "#fff",
          }}
        >
          Terms & Conditions
        </Button>
      ),
      children: (
          <div className="new-main-divv-pageshj">
            <h4 className="new-main-divv-pageshj-heading">   Terms & Conditions</h4>
        <div
          style={{ color: "#fff" }}
          dangerouslySetInnerHTML={{
            __html: content || "<p>Loading Privacy Policy...</p>",
          }}
        />
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          className="Conditions-btn"
          style={{
            background: activeKey === "2" ? "#F2F0F0E3" : "#54545433",
            color: activeKey === "2" ? "#000" : "#fff",
          }}
        >
          Privacy Policy
        </Button>
      ),
      children: (
        <div className="new-main-divv-pageshj">
       <h4 className="new-main-divv-pageshj-heading">   Privacy Policy</h4>
           <div
          style={{ color: "#fff" }}
          dangerouslySetInnerHTML={{
            __html: content || "<p>Loading Privacy Policy...</p>",
          }}
        />
        </div>
       
      ),
    },
    {
      key: "3",
      label: (
        <Button
          className="Conditions-btn"
          style={{
            background: activeKey === "3" ? "#F2F0F0E3" : "#54545433",
            color: activeKey === "3" ? "#000" : "#fff",
          }}
        >
          XP Policy
        </Button>
      ),
      children: (
          <div className="new-main-divv-pageshj">
                   <h4 className="new-main-divv-pageshj-heading">   XP Policy</h4>
        <div
          style={{ color: "#fff" }}
          dangerouslySetInnerHTML={{
            __html: content || "<p>Loading Privacy Policy...</p>",
          }}
        />
        </div>
      ),
    },
    {
      key: "4",
      label: (
        <Button
          className="Conditions-btn"
          style={{
            background: activeKey === "4" ? "#F2F0F0E3" : "#54545433",
            color: activeKey === "4" ? "#000" : "#fff",
          }}
        >
          Accessories
        </Button>
      ),
      children: (
          <div className="new-main-divv-pageshj">
                   <h4 className="new-main-divv-pageshj-heading">   Accessories</h4>
        <div
          style={{ color: "#fff" }}
          dangerouslySetInnerHTML={{
            __html: content || "<p>Loading Privacy Policy...</p>",
          }}
        />
        </div>
      ),
    },
  ];

  return (
    <section>
      <div className="active-main-div active-main-div_main">
        <div className="active-heading-div">
          <h1>Platform Policies</h1>
          <p>
            Review your latest alerts and updates collected from your account
            activity.
          </p>
        </div>
        <div className="tabs-div-Policies">
          <Tabs activeKey={activeKey} onChange={onChange} items={items} />
        </div>
      </div>
    </section>
  );
}

export default PlatformPolicies;
